import { render } from "./OImageInput.vue?vue&type=template&id=8ceb68f4&scoped=true"
import script from "./OImageInput.vue?vue&type=script&lang=js"
export * from "./OImageInput.vue?vue&type=script&lang=js"

import "./OImageInput.vue?vue&type=style&index=0&id=8ceb68f4&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ceb68f4"]])

export default __exports__